export default {
    name: 'classifications',
    component: () => import(/* webpackChunkName: "classifications-Layout" */ '@/modules/classifications/layouts/Layout'),
    children: [
        {
            path: '',
            name: 'dashboard.classifications.index',
            component: () => import(/* webpackChunkName: "classifications-index" */ '@/modules/classifications/views/Index'),
        },
        {
            path: 'create',
            name: 'dashboard.classifications.create',
            component: () => import(/* webpackChunkName: "classifications-create" */ '@/modules/classifications/views/Create'),
        },
        {
            path: ':id/edit',
            name: 'dashboard.classifications.edit',
            component: () => import(/* webpackChunkName: "classifications-edit" */ '@/modules/classifications/views/Edit'),
        },
    ]
}